import { join } from 'path'

import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, notification } from 'antd'

import { APP_ROUTES } from '../../common/constants'
import { apolloService } from '../../common/services'

import { DUPLICATE_BRAND_CURATION_TASK_MUTATION } from '../graphql/mutations'
import { DUPLICATE_BRAND_CURATION_TASK } from '../redux/action-types'

const useDuplicateBrandCurationTaskMutation = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { isDuplicateLoading: isLoading, duplicateError: error } = useSelector(
    store => store.brandCurationTasks.brandCurationTask,
  )

  const onSuccess = useCallback(
    response => {
      const {
        data: { duplicateBrandCurationTask: duplicatedTask },
      } = response

      const notificationKey = `open${Date.now()}`

      notification.success({
        key: notificationKey,
        message: 'Duplication Finished',
        description: `Successfully duplicated the brand curation task`,
        placement: 'topLeft',
        btn: (
          <Button
            onClick={() => {
              navigate(join(APP_ROUTES.BRANDS.fullPath, duplicatedTask.id))
              notification.close(notificationKey)
            }}
          >
            See the task
          </Button>
        ),
      })
    },
    [navigate],
  )

  const mutate = useCallback(
    (id, customName) =>
      apolloService.mutate({
        mutation: DUPLICATE_BRAND_CURATION_TASK_MUTATION,
        variables: { id, customName },
        dispatch,
        action: DUPLICATE_BRAND_CURATION_TASK,
        onSuccess,
      }),
    [dispatch, onSuccess],
  )

  return [mutate, { isLoading, error }]
}

export default useDuplicateBrandCurationTaskMutation
